export default __webpack_public_path__ + "static/media/caret.73d0618f.svg";